import { render, staticRenderFns } from "./ProductModelComponent.vue?vue&type=template&id=1a035a34&scoped=true"
import script from "./ProductModelComponent.vue?vue&type=script&lang=js"
export * from "./ProductModelComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductModelComponent.vue?vue&type=style&index=0&id=1a035a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a035a34",
  null
  
)

export default component.exports